export default __webpack_public_path__ + "static/media/disNonAtt.22358de7.svg";